import * as _ from "lodash";
import * as React from "react";
import styled, { css } from "styled-components";
import { observer } from "mobx-react";
import { FormattedResult } from "app/utils/unitsFormatter";
import { NumberWithUnit } from "app/components/numberWithUnits/NumberWithUnit";
import { Shadows } from "app/styling/shadows";
import { Animations } from "app/styling/animations";

const Title = styled.span`
  ${(props: {}) => css`
    font-size: 16px;
    text-transform: uppercase;
    opacity: 0.7;
  `};
`;

const Content = styled.div`
  ${(props: {}) => css`
    color: white;
  `};
`;
const MetricCardView = styled.div`
  ${(props: {}) => css`
    position: relative;
    padding: 10px;
    border-radius: 5px;
    background-color: transparent;
    animation: ${Animations.FADE_IN} 0.5s forwards ease-out;
  `};
`;

export interface Props {
  formattedValue: FormattedResult;
  title: string;
  isReady: boolean;
  className?: string;
}
export type DefaultPropsKeys = never;

const initialState = {};

type State = Readonly<typeof initialState>;

@observer
export class MetricCard extends React.Component<Props, State> {
  static defaultProps: Pick<Props, DefaultPropsKeys> = {};
  readonly state: State = initialState;

  render() {
    return this.props.isReady ? (
      <MetricCardView className={this.props.className}>
        <Content>
          <Title>{this.props.title}</Title>
          <NumberWithUnit
            value={this.props.formattedValue.formattedLabel}
            unit={this.props.formattedValue.unit}
            valueFontSize={"32px"}
            unitFontSize={"24px"}
          />
        </Content>
      </MetricCardView>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./app/components/metricCard/MetricCard.tsx